// src/components/common/OfflineSalesTerminalLayout/OfflineSalesTerminalLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './OfflineSalesTerminalLayout.module.css';

/**
 * Full-screen POS terminal layout — no sidebar, no header.
 * Content (OfflineSalesTerminal) renders via <Outlet />.
 */
const OfflineSalesTerminalLayout = () => {
  return (
    <div className={styles.terminalRoot}>
      <Outlet />
    </div>
  );
};

export default OfflineSalesTerminalLayout;
